import { useState } from "react";
import { useProtectedAPI } from "./apiService";

export const useGetImportFile = () => {
    const protectedAPI = useProtectedAPI()
    const [progress, setProgress] = useState(0);

    const getImportFile = async () => {
        const url = `/admin/import/users`

        const response = await protectedAPI.get(url, {
            timeout: 0,
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                const percentCompleted = progressEvent.progress > 0 ? (Math.round(progressEvent.progress * 100)) : 0;
                setProgress(percentCompleted);
                if (percentCompleted === 100) {
                    setTimeout(() => setProgress(0), 1000);
                }
            },
        });
        return response
    }
    
    return {getImportFile, progress};
}



export const useImportUsers = () => {
    const protectedAPI = useProtectedAPI();
    const [progress, setProgress] = useState(null);

    const importUsers = async (file, dry_run) => {
        const formData = new FormData();
        formData.append("data", file);

        const url = `/admin/import/users?dry_run=${dry_run}`

        const response = await protectedAPI.post(url, formData, {
            timeout: 0,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = progressEvent.progress > 0 ? (Math.round(progressEvent.progress * 100)) : 0;
                setProgress(percentCompleted);
                if (percentCompleted === 100) {
                    setTimeout(() => setProgress(0), 1000);
                }
            },
        });
        return response.data
    };

    return { importUsers, progress };
}